// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecentByStatusList_panel__huovL {
  padding: 20px 30px;
}

.RecentByStatusList_header__Xd5II {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f4f5f7;
}

.RecentByStatusList_headerLeft__1VdL6 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
  min-width: 0;
}

.RecentByStatusList_titleRow__VZ6e- {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.RecentByStatusList_filtersRow__hYMkA {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.RecentByStatusList_searchBox__FIoOE {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 220px;
  max-width: 360px;
  margin-left: auto;
}

.RecentByStatusList_searchIcon__tl45Z {
  position: absolute;
  left: 10px;
  color: #acacac;
  font-size: 12px;
  pointer-events: none;
}

.RecentByStatusList_searchInput__b37Ub {
  width: 100%;
  padding: 6px 28px 6px 28px;
  font-size: 13px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: #838383;
}
.RecentByStatusList_searchInput__b37Ub:focus {
  outline: none;
  border-color: var(--primary-color);
}
.RecentByStatusList_searchInput__b37Ub::placeholder {
  color: #acacac;
}

.RecentByStatusList_searchClear__xsDmk {
  position: absolute;
  right: 6px;
  width: 22px;
  height: 22px;
  background: none;
  border: none;
  cursor: pointer;
  color: #acacac;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.RecentByStatusList_searchClear__xsDmk:hover {
  background: #f4f5f7;
  color: #838383;
}

.RecentByStatusList_title__VZtxB {
  font-size: 16.38px;
  font-weight: 600;
  color: #838383;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.RecentByStatusList_filters__HvJ-v {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.RecentByStatusList_chip__54Eif {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  background: #f4f5f7;
  border: 1px solid #dbdbdb;
  font-size: 11px;
  color: #838383;
  white-space: nowrap;
}
.RecentByStatusList_chip__54Eif strong {
  font-weight: 600;
  color: #838383;
}

.RecentByStatusList_chipLabel__0nSUY {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 9px;
  color: #acacac;
}

.RecentByStatusList_chipStatus__ybgeJ {
  background: rgba(87, 188, 143, 0.12);
  border-color: rgba(87, 188, 143, 0.35);
}
.RecentByStatusList_chipStatus__ybgeJ strong {
  color: #2d8758;
}

.RecentByStatusList_chip_processed__U24nn {
  background: rgba(87, 188, 143, 0.15);
  border-color: rgba(87, 188, 143, 0.4);
}
.RecentByStatusList_chip_processed__U24nn strong {
  color: #2d8758;
}

.RecentByStatusList_chip_processing__cUbh4 {
  background: rgba(59, 127, 212, 0.15);
  border-color: rgba(59, 127, 212, 0.4);
}
.RecentByStatusList_chip_processing__cUbh4 strong {
  color: #2c5b9c;
}

.RecentByStatusList_chip_pending__G2Gud {
  background: rgba(0, 188, 212, 0.15);
  border-color: rgba(0, 188, 212, 0.4);
}
.RecentByStatusList_chip_pending__G2Gud strong {
  color: #008ba3;
}

.RecentByStatusList_chip_waiting_archive__rlL6F {
  background: rgba(100, 181, 246, 0.15);
  border-color: rgba(100, 181, 246, 0.4);
}
.RecentByStatusList_chip_waiting_archive__rlL6F strong {
  color: #1976d2;
}

.RecentByStatusList_chip_duplicate__z\\+mne {
  background: rgba(142, 106, 203, 0.15);
  border-color: rgba(142, 106, 203, 0.4);
}
.RecentByStatusList_chip_duplicate__z\\+mne strong {
  color: #6244a0;
}

.RecentByStatusList_chip_upload_failed__p3sY\\+ {
  background: rgba(239, 161, 44, 0.15);
  border-color: rgba(239, 161, 44, 0.4);
}
.RecentByStatusList_chip_upload_failed__p3sY\\+ strong {
  color: #b8761d;
}

.RecentByStatusList_chip_failed__v57Tv {
  background: rgba(223, 103, 103, 0.15);
  border-color: rgba(223, 103, 103, 0.4);
}
.RecentByStatusList_chip_failed__v57Tv strong {
  color: #a14444;
}

.RecentByStatusList_chip_no_data__y1Az6 {
  background: #f4f5f7;
  border-color: #dbdbdb;
}
.RecentByStatusList_chip_no_data__y1Az6 strong {
  color: #838383;
}

.RecentByStatusList_count__eqFOy {
  margin-left: 5px;
  font-weight: 400;
  color: #acacac;
  text-transform: none;
  letter-spacing: 0;
}

.RecentByStatusList_closeBtn__zgKvd {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #838383;
  padding: 0 5px;
}
.RecentByStatusList_closeBtn__zgKvd:hover {
  opacity: 0.7;
}

.RecentByStatusList_empty__KOkZy {
  color: #acacac;
  font-size: 14px;
  margin: 10px 0;
}

.RecentByStatusList_loaderWrap__r4cCV {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.RecentByStatusList_list__4MMxX {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 420px;
  overflow-y: auto;
}

.RecentByStatusList_row__rkDxQ {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 5px 10px;
  background: none;
  border: none;
  border-bottom: 1px solid #f4f5f7;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  color: #838383;
}
.RecentByStatusList_row__rkDxQ:hover {
  background: #f4f5f7;
}
.RecentByStatusList_row__rkDxQ {
  -webkit-user-select: text;
          user-select: text;
  box-sizing: border-box;
}

.RecentByStatusList_chevron__I6MHJ {
  font-size: 10px;
  color: #acacac;
  transition: transform 0.15s ease;
}

.RecentByStatusList_chevronOpen__Bz0CK {
  transform: rotate(90deg);
}

.RecentByStatusList_itemExpanded__Vn8S5 .RecentByStatusList_row__rkDxQ {
  background: #f4f5f7;
  border-bottom-color: transparent;
}

.RecentByStatusList_accordion__fnNaC {
  background: rgba(0, 0, 0, 0.02);
  padding: 10px 20px;
  border-bottom: 1px solid #f4f5f7;
}

.RecentByStatusList_pager__EloWy {
  display: flex;
  align-items: center;
  gap: 4px;
}

.RecentByStatusList_pagerBtn__JLoJP {
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #838383;
  font-size: 12px;
}
.RecentByStatusList_pagerBtn__JLoJP:hover:not(:disabled) {
  background: #f4f5f7;
  border-color: #acacac;
}
.RecentByStatusList_pagerBtn__JLoJP:disabled {
  cursor: default;
  opacity: 0.4;
}

.RecentByStatusList_pagerLabel__u0M9W {
  font-size: 12px;
  color: #838383;
  margin: 0 5px;
  min-width: 90px;
  text-align: center;
  font-family: monospace;
}

.RecentByStatusList_date__q0iqe {
  font-family: monospace;
  font-weight: 600;
  color: var(--primary-color);
  min-width: 90px;
}

.RecentByStatusList_centerName__QG-5l {
  flex: 1 1;
}

.RecentByStatusList_centerExt__k4pjy {
  color: #acacac;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/RecentByStatusList/RecentByStatusList.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SCDS;EDET,mBCFS;EDGT,mBCJS;EDKT,gCAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QCXS;EDYT,SAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SCjBS;EDkBT,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SCzBS;ED0BT,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,cE5CS;EF6CT,eAAA;EACA,oBAAA;AAFF;;AAKA;EACE,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBE/CM;EFgDN,yBAAA;EACA,kBC7Dc;ED8Dd,cEvDS;AFqDX;AAIE;EACE,aAAA;EACA,kCEpEM;AFkEV;AAKE;EACE,cEhEO;AF6DX;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cE5ES;EF6ET,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAJF;AAME;EACE,mBErFO;EFsFP,cEnFO;AF+EX;;AAQA;EACE,kBC3Ea;ED4Eb,gBAAA;EACA,cE1FS;EF2FT,SAAA;EACA,yBAAA;EACA,sBAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBE/GS;EFgHT,yBAAA;EACA,eAAA;EACA,cE/GS;EFgHT,mBAAA;AALF;AAOE;EACE,gBAAA;EACA,cEpHO;AF+GX;;AASA;EACE,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,cE7HS;AFuHX;;AASA;EACE,oCAAA;EACA,sCAAA;AANF;AAOE;EAAS,cAAA;AAJX;;AAOA;EAAwB,oCAAA;EAAsC,qCAAA;AAF9D;AAEqG;EAAS,cAAA;AAC9G;;AAAA;EAAwB,oCAAA;EAAsC,qCAAA;AAK9D;AALqG;EAAS,cAAA;AAQ9G;;AAPA;EAAwB,mCAAA;EAAqC,oCAAA;AAY7D;AAZmG;EAAS,cAAA;AAe5G;;AAdA;EAAwB,qCAAA;EAAuC,sCAAA;AAmB/D;AAnBuG;EAAS,cAAA;AAsBhH;;AArBA;EAAwB,qCAAA;EAAuC,sCAAA;AA0B/D;AA1BuG;EAAS,cAAA;AA6BhH;;AA5BA;EAAwB,oCAAA;EAAsC,qCAAA;AAiC9D;AAjCqG;EAAS,cAAA;AAoC9G;;AAnCA;EAAwB,qCAAA;EAAuC,sCAAA;AAwC/D;AAxCuG;EAAS,cAAA;AA2ChH;;AA1CA;EAAwB,mBE/Ib;EF+IoC,qBE9IpC;AF6LX;AA/CwE;EAAS,cE5ItE;AF8LX;;AAhDA;EACE,gBC/IS;EDgJT,gBAAA;EACA,cElJS;EFmJT,oBAAA;EACA,iBAAA;AAmDF;;AAhDA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cE5JS;EF6JT,cAAA;AAmDF;AAjDE;EACE,YAAA;AAmDJ;;AA/CA;EACE,cEtKS;EFuKT,eC/Je;EDgKf,cAAA;AAkDF;;AA/CA;EACE,aAAA;EACA,uBAAA;EACA,aC/KW;ADiOb;;AA/CA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAkDF;;AA/CA;EACE,aAAA;EACA,mBAAA;EACA,SC1LS;ED2LT,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cEpMS;AFsPX;AAhDE;EACE,mBE1MO;AF4PX;AAjEA;EAkBE,yBAAA;UAAA,iBAAA;EACA,sBAAA;AAkDF;;AA/CA;EACE,eAAA;EACA,cEjNS;EFkNT,gCAAA;AAkDF;;AA/CA;EACE,wBAAA;AAkDF;;AA/CA;EACE,mBE5NS;EF6NT,gCAAA;AAkDF;;AA/CA;EACE,+BAAA;EACA,kBAAA;EACA,gCAAA;AAkDF;;AA/CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAkDF;;AA/CA;EACE,gBErOM;EFsON,yBAAA;EACA,kBCnPc;EDoPd,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cEnPS;EFoPT,eAAA;AAkDF;AAhDE;EACE,mBE1PO;EF2PP,qBEzPO;AF2SX;AA/CE;EACE,eAAA;EACA,YAAA;AAiDJ;;AA7CA;EACE,eAAA;EACA,cEnQS;EFoQT,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAgDF;;AA7CA;EACE,sBAAA;EACA,gBAAA;EACA,2BEtRQ;EFuRR,eAAA;AAgDF;;AA7CA;EACE,SAAA;AAgDF;;AA7CA;EACE,cEvRS;EFwRT,eAAA;AAgDF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.panel {\n  padding: $padding-l $padding-xl;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: $margin-m;\n  margin-bottom: $margin-m;\n  padding-bottom: $margin-s;\n  border-bottom: 1px solid $grey-100;\n}\n\n.headerLeft {\n  display: flex;\n  flex-direction: column;\n  gap: $margin-s;\n  flex: 1;\n  min-width: 0;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: $margin-l;\n  flex-wrap: wrap;\n}\n\n.filtersRow {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n  flex-wrap: wrap;\n}\n\n.searchBox {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 220px;\n  max-width: 360px;\n  margin-left: auto;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 10px;\n  color: $grey-300;\n  font-size: 12px;\n  pointer-events: none;\n}\n\n.searchInput {\n  width: 100%;\n  padding: 6px 28px 6px 28px;\n  font-size: 13px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  color: $grey-400;\n\n  &:focus {\n    outline: none;\n    border-color: $primary;\n  }\n\n  &::placeholder {\n    color: $grey-300;\n  }\n}\n\n.searchClear {\n  position: absolute;\n  right: 6px;\n  width: 22px;\n  height: 22px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: $grey-300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n\n  &:hover {\n    background: $grey-100;\n    color: $grey-400;\n  }\n}\n\n.title {\n  font-size: $h3-font-size;\n  font-weight: 600;\n  color: $grey-400;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  background: $grey-100;\n  border: 1px solid $grey-200;\n  font-size: 11px;\n  color: $grey-400;\n  white-space: nowrap;\n\n  strong {\n    font-weight: 600;\n    color: $grey-400;\n  }\n}\n\n.chipLabel {\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 9px;\n  color: $grey-300;\n}\n\n.chipStatus {\n  background: rgba(87, 188, 143, 0.12);\n  border-color: rgba(87, 188, 143, 0.35);\n  strong { color: #2d8758; }\n}\n\n.chip_processed       { background: rgba(87, 188, 143, 0.15); border-color: rgba(87, 188, 143, 0.4); strong { color: #2d8758; } }\n.chip_processing      { background: rgba(59, 127, 212, 0.15); border-color: rgba(59, 127, 212, 0.4); strong { color: #2c5b9c; } }\n.chip_pending         { background: rgba(0, 188, 212, 0.15); border-color: rgba(0, 188, 212, 0.4); strong { color: #008ba3; } }\n.chip_waiting_archive { background: rgba(100, 181, 246, 0.15); border-color: rgba(100, 181, 246, 0.4); strong { color: #1976d2; } }\n.chip_duplicate       { background: rgba(142, 106, 203, 0.15); border-color: rgba(142, 106, 203, 0.4); strong { color: #6244a0; } }\n.chip_upload_failed   { background: rgba(239, 161, 44, 0.15); border-color: rgba(239, 161, 44, 0.4); strong { color: #b8761d; } }\n.chip_failed          { background: rgba(223, 103, 103, 0.15); border-color: rgba(223, 103, 103, 0.4); strong { color: #a14444; } }\n.chip_no_data         { background: $grey-100; border-color: $grey-200; strong { color: $grey-400; } }\n\n.count {\n  margin-left: $margin-s;\n  font-weight: 400;\n  color: $grey-300;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: $grey-400;\n  padding: 0 $padding-s;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.empty {\n  color: $grey-300;\n  font-size: $base-font-size;\n  margin: $margin-m 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xl;\n}\n\n.list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n  width: 100%;\n  padding: $padding-s $padding-m;\n  background: none;\n  border: none;\n  border-bottom: 1px solid $grey-100;\n  cursor: pointer;\n  text-align: left;\n  font-size: 13px;\n  color: $grey-400;\n\n  &:hover {\n    background: $grey-100;\n  }\n  // A div, not a button: ids inside must stay selectable (see rowSelection.js).\n  user-select: text;\n  box-sizing: border-box;\n}\n\n.chevron {\n  font-size: 10px;\n  color: $grey-300;\n  transition: transform 0.15s ease;\n}\n\n.chevronOpen {\n  transform: rotate(90deg);\n}\n\n.itemExpanded .row {\n  background: $grey-100;\n  border-bottom-color: transparent;\n}\n\n.accordion {\n  background: rgba(0, 0, 0, 0.02);\n  padding: $padding-m $padding-l;\n  border-bottom: 1px solid $grey-100;\n}\n\n.pager {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pagerBtn {\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: $grey-400;\n  font-size: 12px;\n\n  &:hover:not(:disabled) {\n    background: $grey-100;\n    border-color: $grey-300;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.4;\n  }\n}\n\n.pagerLabel {\n  font-size: 12px;\n  color: $grey-400;\n  margin: 0 $margin-s;\n  min-width: 90px;\n  text-align: center;\n  font-family: monospace;\n}\n\n.date {\n  font-family: monospace;\n  font-weight: 600;\n  color: $primary;\n  min-width: 90px;\n}\n\n.centerName {\n  flex: 1;\n}\n\n.centerExt {\n  color: $grey-300;\n  font-size: 12px;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `RecentByStatusList_panel__huovL`,
	"header": `RecentByStatusList_header__Xd5II`,
	"headerLeft": `RecentByStatusList_headerLeft__1VdL6`,
	"titleRow": `RecentByStatusList_titleRow__VZ6e-`,
	"filtersRow": `RecentByStatusList_filtersRow__hYMkA`,
	"searchBox": `RecentByStatusList_searchBox__FIoOE`,
	"searchIcon": `RecentByStatusList_searchIcon__tl45Z`,
	"searchInput": `RecentByStatusList_searchInput__b37Ub`,
	"searchClear": `RecentByStatusList_searchClear__xsDmk`,
	"title": `RecentByStatusList_title__VZtxB`,
	"filters": `RecentByStatusList_filters__HvJ-v`,
	"chip": `RecentByStatusList_chip__54Eif`,
	"chipLabel": `RecentByStatusList_chipLabel__0nSUY`,
	"chipStatus": `RecentByStatusList_chipStatus__ybgeJ`,
	"chip_processed": `RecentByStatusList_chip_processed__U24nn`,
	"chip_processing": `RecentByStatusList_chip_processing__cUbh4`,
	"chip_pending": `RecentByStatusList_chip_pending__G2Gud`,
	"chip_waiting_archive": `RecentByStatusList_chip_waiting_archive__rlL6F`,
	"chip_duplicate": `RecentByStatusList_chip_duplicate__z+mne`,
	"chip_upload_failed": `RecentByStatusList_chip_upload_failed__p3sY+`,
	"chip_failed": `RecentByStatusList_chip_failed__v57Tv`,
	"chip_no_data": `RecentByStatusList_chip_no_data__y1Az6`,
	"count": `RecentByStatusList_count__eqFOy`,
	"closeBtn": `RecentByStatusList_closeBtn__zgKvd`,
	"empty": `RecentByStatusList_empty__KOkZy`,
	"loaderWrap": `RecentByStatusList_loaderWrap__r4cCV`,
	"list": `RecentByStatusList_list__4MMxX`,
	"row": `RecentByStatusList_row__rkDxQ`,
	"chevron": `RecentByStatusList_chevron__I6MHJ`,
	"chevronOpen": `RecentByStatusList_chevronOpen__Bz0CK`,
	"itemExpanded": `RecentByStatusList_itemExpanded__Vn8S5`,
	"accordion": `RecentByStatusList_accordion__fnNaC`,
	"pager": `RecentByStatusList_pager__EloWy`,
	"pagerBtn": `RecentByStatusList_pagerBtn__JLoJP`,
	"pagerLabel": `RecentByStatusList_pagerLabel__u0M9W`,
	"date": `RecentByStatusList_date__q0iqe`,
	"centerName": `RecentByStatusList_centerName__QG-5l`,
	"centerExt": `RecentByStatusList_centerExt__k4pjy`
};
export default ___CSS_LOADER_EXPORT___;
